import React from 'react'

const ExternalLink = ({ children, href, ...others }) => (
  <a href={href} rel="noopener noreferrer" target="_blank" {...others}>
    {children}
  </a>
)

export default ExternalLink
